import { axiosInstance } from '../services/axiosInstance';
import { Grade, GrantRow, viewerGrade } from './menuCatalog';

export type PoolMonitorGrants = Record<string, GrantRow>;

let cachedGrants: PoolMonitorGrants | null = null;
let cachedAt = 0;
const CACHE_MS = 15000;

export async function fetchPoolMonitorGrants(force = false): Promise<PoolMonitorGrants> {
  const now = Date.now();
  if (!force && cachedGrants && now - cachedAt < CACHE_MS) {
    return cachedGrants;
  }
  const { data } = await axiosInstance.get('/api/brand-menu/pool-monitor-policy');
  const raw = data?.grants && typeof data.grants === 'object' ? data.grants : {};
  const next: PoolMonitorGrants = {};
  for (const [key, row] of Object.entries(raw)) {
    if (!row || typeof row !== 'object') continue;
    const r = row as Partial<GrantRow>;
    next[String(key)] = {
      super: r.super !== false,
      manager: r.manager !== false,
      facility: r.facility !== false,
    };
  }
  cachedGrants = next;
  cachedAt = now;
  return next;
}

export function invalidatePoolMonitorGrantsCache(): void {
  cachedGrants = null;
  cachedAt = 0;
}

/** brand 등급은 전부 허용. 정책에 없으면 허용(기본 ON). */
export function isPoolMonitorGranted(
  poolId: number | string,
  grade: Grade | 'brand',
  grants: PoolMonitorGrants | null | undefined
): boolean {
  if (grade === 'brand') return true;
  if (!grants) return true;
  const row = grants[String(poolId)];
  if (!row) return true;
  return row[grade] !== false;
}

export function filterPoolsByMonitorPolicy<T extends { id?: number | string }>(
  pools: T[],
  user: { is_superuser?: boolean; is_brand_manager?: boolean } | null | undefined,
  authenticated: boolean,
  grants: PoolMonitorGrants | null | undefined
): T[] {
  const grade = viewerGrade(user, authenticated);
  return pools.filter((p) => {
    const id = p?.id;
    if (id == null || id === '') return false;
    return isPoolMonitorGranted(id, grade, grants);
  });
}
